export const DEFAULT_TINYMCE_OPTIONS = {
    base_url: '/tinymce',
    suffix: '.min',
    license_key: 'gpl',
    language: 'pt_BR',
    language_url: '/assets/tinymce/langs/pt_BR.js',
    promotion: false,

    height: '300px',
    body_class: 'tinymce-body',
    theme: 'silver',
    statusbar: false,
    menubar: false,
    contextmenu: false,
    branding: false,
    fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt',

    // evita que o tinyMce altere as URLs das imagens fornecidas
    relative_urls: false,
    remove_script_host: false,
    convert_urls: false,
    default_link_target: '_blank',

    table_toolbar: '',

    mobile: {
        theme: 'mobile',
        plugins: ['autosave', 'lists', 'autolink'],
        toolbar: ['undo', 'bold', 'italic', 'blocks'],
        height: '50px'
    },
};
